import { cn } from "@/shared/lib/utils.js";

/**
 * TipoBadge — bloque mono cuadrado para el tipo de informe.
 *   IE = negro · IS = ámbar · AC = teal. Tokens --tipo-{ie,is,ac}-*.
 *
 * Union autocontenido — shared/ui NO importa de features. Coincide
 * estructuralmente con TipoInforme del feature reports.
 */
type TipoInforme = "IE" | "IS" | "AC";

interface TipoBadgeProps {
  tipo: TipoInforme;
  className?: string;
}

const TIPO_CLASS: Record<TipoInforme, string> = {
  IE: "bg-[var(--tipo-ie-bg)] text-[var(--tipo-ie-text)]",
  IS: "bg-[var(--tipo-is-bg)] text-[var(--tipo-is-text)]",
  AC: "bg-[var(--tipo-ac-bg)] text-[var(--tipo-ac-text)]",
};

export function TipoBadge({ tipo, className }: TipoBadgeProps) {
  return (
    <span
      className={cn(
        "inline-flex h-5 w-7 items-center justify-center rounded-(--radius-badge) font-mono text-[0.625rem] font-bold uppercase tracking-wider",
        TIPO_CLASS[tipo],
        className,
      )}
    >
      {tipo}
    </span>
  );
}
